export default __webpack_public_path__ + "static/future-roadmap-header-8345bbe71d415465a79f3a8c6cbe213268b411acb714d9d8b4ddde7a7151a7b5.png";